/* 字符串分割 */
import Vue from "vue";

const split = (str, separator, defaultVal) => {
    if (str == null || str == '') {
        return defaultVal
    } else {
        return str.split(separator)
    }
}
/**
 * 数组格式化输出
 */
const separatorArray = (array, separator) => {
    if (array.length == 0) {
        return ''
    }
    return array.toString().replace(/,/g, separator)
}

/**
 * 金额格式化
 * @param str
 * @returns {*}
 */
const amountFormat = (str, unit) => {
    if (!str) {
        return str = '0' + unit
    }

    str += ''
    if (str === '0') {
        return str + unit
    }

    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + unit
}

const rateUtilConversion = (str, unit) => {
    if (!str) {
        return str = ''
    }

    if (str === 'day') {
        return '日'
    } else if (str === 'month') {
        return '月'
    } else if (str === 'year') {
        return '年'
    }
}

const numNull = (str, unit) => {
    if (!str) {
        return str = '0' + unit
    }
    return str + unit
}

/**
 * 金额格式化万元
 * @param str
 * @returns {*}
 */
const amountFormatWan = (str) => {
    if (str === '0') {
        return str
    }
    if (!str) {
        return ''
    }
    let wan = parseFloat(str) / parseInt(10000)
    return wan.toFixed(0)
}

const dateFormat = (time) => {
    if (!time) {
        return ""
    }

    let unixTimestamp = new Date(time);
    return unixTimestamp.toLocaleString();
}

const dateFormatStr = (str) => {
    if (str==""||!str) {
        return ""
    }
    return /\d{4}-\d{1,2}-\d{1,2}/g.exec(str)
}

const timeFormat = (time) => {
    if (!time) {
        return ""
    }
    let unixTimestamp = new Date(time);
    return unixTimestamp.toLocaleTimeString();
}

const approveNoFormat= (str,unit) => {
    if (!str) {
        return str = ''
    }
    if (unit === 'day') {
        return str+'天'
    } else if (unit === 'month') {
        return str+'月'
    }
}

const filterUserMaritalStatusText = (text) => {
    switch (text) {
        case '1' :
            return '未婚';
        case '2' :
            return '已婚';
        case '3' :
            return '离异';
        case '4' :
            return '丧偶';
        case '5' :
            return '已婚有子';
        case '6' :
            return '已婚无子';
    }
}

const filterAuditType = (text) => {
    if (text === '0') {
        return "业务受理"
    } else if (text === '1') {
        return "专员初审 "
    } else if (text === '2') {
        return "下戶面谈 "
    } else if (text === '3') {
        return "风控初审 "
    } else if (text === '4') {
        return "风控复审 "
    } else if (text === '5') {
        return "贷审会会审 "
    } else if (text === '6') {
        return "资方审批 "
    } else if (text === '7') {
        return "合同/抵押/公证"
    } else if (text === '8') {
        return "最终审核/推送资方"
    } else if (text === '9') {
        return "担保方审批 "
    } else if (text === '10') {
        return "提款申请 "
    } else if (text === '41') {
    } else if (text === '11') {
        return "提款确认"
    } else if (text === '41') {
        return "复审"
    } else if (text === '11') {
        return "放款 "
    } else if (text === '12') {
        return "总经理审批 "
    } else if (text === '13') {
        // return "总经理审批 "
    } else if (text === '14') {
        return "贷审会审核 "
    } else if (text === '15') {
        return "橙易贷专员初审"
    } else if (text === '16') {
        return "贷后管理"
    } else if (text === '17') {
        return "新建客户"
    } else if (text === '18') {
        return "新建车辆"
    } else if (text === '19') {
        return "财务已结清还款"
    } else if (text === '20') {
        return "风控确认返还他项权证"
    } else if (text === '21') {
        return "解抵押"
    } else if (text === '49') {
        return "业务受理"
    } else if (text === '50') {
        return "预审"
    } else if (text === '51') {
        return "派单"
    } else if (text === '52') {
        return "调查核行"
    } else if (text === '53') {
        return "风险初审"
    } else if (text === '54') {
        return "风控复审"
    } else if (text === '55') {
        return "总经理审批"
    } else if (text === '56') {
        return "签订手续"
    } else if (text === '57') {
        return "要件入库"
    } else if (text === '58') {
        return "申请信托审核"
    } else if (text === '59') {
        return "财务放款"
    } else if (text === '60') {
        return "银行确认扣款"
    } else if (text === '61') {
        return "返回放款"
    } else if (text === '99') {
        return "其他"
    } else {
        return text
    }
}

const filterAuditStatus = (status) => {
    switch (status) {
        case '0' :
            return '未通过';
        case '1' :
            return '通过';
        case '2' :
            return '退回初审';
        case '3' :
            return '驳回';
        case '4' :
            return '拒绝';
        case '5' :
            return '拒绝件';
        case '6' :
            return '客户放弃';
        case '7' :
            return '挂单';
    }
}

const unescape = (html) => {
    if (html != '') {
        return html
            .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, '\'')
    }
    return html
}

Date.prototype.toLocaleString = function () {
    return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate();
}

Date.prototype.toLocaleTimeString = function () {
    return this.getFullYear()
        + "-" + (this.getMonth() + 1)
        + "-" + this.getDate()
        + " " + this.getHours()
        + ":" + this.getMinutes()
        + ":" + this.getSeconds()
}

/* 时间格式化 年月日*/
const dateYmdFormat = (time) => {
    if (time) {
        var oDate = new Date();
        oDate.setTime(time);
        var y = oDate.getFullYear();
        var M = oDate.getMonth() + 1;
        var d = oDate.getDate();
        if ((M + "").length == 1) {
            M = "0" + M;
        }
        if ((d + "").length == 1) {
            d = "0" + d;
        }
        return y + '-' + M + '-' + d;
    }
}

const omitStr = (str) => {
    if (str) {
        if(str.length > 12){
            return str.substring(0,12) + '...'
        }
    }
    return str
}

const subTypeFormat = (value) => {
    const subTypeMap= {
        'OutletsChannel':'直营',
        'PrincipalChannel':'兜底渠道',
        'InterestChannel':'兜息渠道',
        'FundingChannel':'配资渠道'
    }
    return  subTypeMap[value]
}

export default {
    omitStr,
    split,
    separatorArray,
    amountFormat,
    amountFormatWan,
    numNull,
    dateFormat,
    unescape,
    timeFormat,
    rateUtilConversion,
    filterAuditStatus,
    filterAuditType,
    dateYmdFormat,
    approveNoFormat,
    dateFormatStr,
    subTypeFormat
}
